export default __webpack_public_path__ + "assets/models/398d4ae1540dd209e7a9d83570dbb6dd.glb";